import { Avatar, Button, Col, Divider, Input, Layout, Modal, PageHeader, Row, Table, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { deleteEntity, fetchEntities } from '../../helpers/crud';
import {useParams, withRouter} from 'react-router';
import Column from 'antd/lib/table/Column';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { API_URL } from '../../Constants';
import xhr from '../../helpers/xhr'

const { Search } = Input;
const { Content } = Layout;
const { confirm } = Modal;

const mapState = state => ({
  permissions: state.permissions,
});

const mapDispatch = dispatch => ({});

function InboundDetail(props) {
  const [results, setResults] = useState();
  const [originalResults, setOriginalResults] = useState();
  const [loading, setLoading] = useState();
  const urlParams = useParams()
  const [params, setParams] = useState();
  const [accessGranted, setAccessGranted] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: 50,
  });

  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const fetch = async (params = {}) => {
      setLoading(true);

      const { data } = await fetchEntities('outbound-instruction-rows/grouped_by_product', {...params, uuid: urlParams.uuid}, source.token);

      if (data) {
        setLoading(false);
        setResults(data);
        setOriginalResults(data);
        // setPagination(p => {
        //   return { ...p, total: data.count };
        // });

        return data;
      }
    };

    fetch(params);

    return () => {
      source.cancel('Operation canceled by the user.');
    };
  }, [props.permissions, accessGranted]);

  const onSearch = value => {
    if (!value) {
      return setResults(originalResults);
    }

    setResults(results.filter(entry => {
      if (entry.product_name && entry.product_name.toLowerCase().includes(value.toLowerCase()))
      {
        return true;
      }

      else if (entry.product_code && entry.product_code.toLowerCase().includes(value.toLowerCase()))
      {
        return true;
      }

      else if (entry.product_description && entry.product_description.toLowerCase().includes(value.toLowerCase()))
      {
        return true;
      }

      else if (entry.batch_number && entry.batch_number.toLowerCase().includes(value.toLowerCase()))
      {
        return true;
      }

      return false;
    }));
  };

const doExport = () => {
    return xhr().post(`${API_URL}/generate-token/`, null, {
      headers: {
        'Authorization': `Token ${localStorage.getItem('claresse_token')}`
      }
      }).then((response) => {
        window.open(`${API_URL}/uitslagen/?TOKEN=${response.data.key}&uuid=${urlParams.uuid}`, '_blank');
      })
  }

  function getTitle(){
  let title = 'Pallets uitslag: ';
    if (results?.length) {
      title += results[0].outbound_instruction__client_reference_number + ' - ';
      title += (results[0].outbound_instruction__client__name ?? " ");
      return title
    }

    return null;
  }

  return (
    <Layout>
      <PageHeader title={getTitle()} />
      <Content
        style={{
          background: '#fff',
          padding: 24,
          margin: 0,
          minHeight: 280,
        }}
      >
        <>
          <Row>
            <Col
              lg={{
                span: 6,
              }}
              xs={24}
              style={{ marginBottom: 20 }}
            >
              <Search allowClear placeholder="Zoek op artikel, omschrijving of batch..." onSearch={onSearch} style={{ width: '100%' }} />
            </Col>
            <Col
              lg={{
                span: 6,
              }}
              xs={24}
              style={{ marginLeft: 20, marginBottom: 20 }}>
                <Button type="primary" onClick={doExport}>
                  Exporteren
                </Button>
            </Col>
          </Row>

          <Table
            scroll={{ x: true }}
            size="middle"
            rowClassName={(record, index) => (index % 2 ? 'even' : 'odd')}
            rowKey={record => record.id}
            dataSource={results}
            pagination={false}
            // pagination={pagination}
            loading={loading}
          >
            <Column
              title="Artikel"
              sorter={(a, b) => a.product_name && a.product_name.localeCompare(b.product_name)}
              key="product_name"
              dataIndex="product_name"
            />

          <Column
              title="Artikelcode"
              dataIndex="product_code"
              sorter={(a, b) => a.product_code && a.product_code.localeCompare(b.product_code)}
            />
            <Column
              title="Artikelomschrijving"
              sorter={(a, b) => a.product_description && a.product_description.localeCompare(b.product_description)}
              dataIndex="product_description"
            />
            <Column title="Aantal pallets" sorter={(a, b) => a.pallet_qty - b.pallet_qty} dataIndex="pallet_qty" />
            <Column
              title="Kg"
              sorter={(a, b) => a.colli_qty_ordered - b.colli_qty_ordered}
              dataIndex="colli_qty_ordered" render={(value)=> value ? Math.round(value * 100) / 10000 : "" } />
            <Column
              title="Verpakking"
              dataIndex="qty_uom_name"
              sorter={(a, b) => a.qty_uom_name && a.qty_uom_name.localeCompare(b.qty_uom_name)}
            />
            <Column
              title="THT"
              dataIndex="best_before_date"
              render={value => {
                if (value) {
                  return moment(value).format('DD-MM-YYYY');
                }

                return value;
              }}
              sorter={(a, b) => moment(a.best_before_date).unix() - moment(b.best_before_date).unix()}
            />

            <Column
              title="Batch/Lot"
              dataIndex="batch_number"
              sorter={(a, b) => a.batch_number && a.batch_number.localeCompare(b.batch_number)}
            />

            <Column
              title="Productiedatum"
              dataIndex="production_date"
              render={value => {
                if (value) {
                  return moment(value).format('DD-MM-YYYY');
                }

                return value;
              }}
              sorter={(a, b) => moment(a.production_date).unix() - moment(b.production_date).unix()}
            />

            <Column
              title="Status"
              dataIndex="pallet_status"
              sorter={(a, b) => a.pallet_status && a.pallet_status.localeCompare(b.pallet_status)}
            />

            <Column
              title="Inslagdatum"
              dataIndex="inbound_instruction_date"
              render={value => {
                if (value) {
                  return moment(value).format('DD-MM-YYYY');
                }

                return value;
              }}
              sorter={(a, b) => moment(a.inbound_instruction_date).unix() - moment(b.inbound_instruction_date).unix()}
            />
          </Table>
        </>
      </Content>
    </Layout>
  );
}

export default withRouter(connect(mapState, mapDispatch)(InboundDetail));
